"use strict";

exports.__esModule = true;
exports.default = void 0;

var _modal = require("./modal");

var _modal2 = require("../../directives/modal");

var _plugins = require("../../utils/plugins");

var components = {
  BModal: _modal.default
};
var plugins = {
  BModalDirectivePlugin: _modal2.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components,
    plugins: plugins
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/modal/index.js
// module id = 477
// module chunks = 0